module.exports = "https://health.dajiuxing.com.cn/img/assets/rightsDetails/self-operated/self-operatedbg-2280.jpg"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FrightsDetails%2Fself-operated%2Fself-operatedbg-2280.jpg
// module id = jWVd
// module chunks = 93